import Link from "next/link";
import React from "react";
import {Fade} from "./../components/Animation";
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
// import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

import "react-toastify/dist/ReactToastify.css";
import "animate.css";

const FormGstEstimate = () => {
  return (
    <div className="grid place-center">
      <Fade triggerOnce delay={500}>
        <div className="block">
          <h1 className="tracking-tight 2xl:tracking-wide font-configSemiBold text-2xl xxs:text-3xl md:text-4xl text-white px-6 xxs:px-2">
            Get Solar + Battery On Your Terms!
          </h1>
          <p className="tracking-wider text-white py-1 font-configMedium text-base xxs:text-lg md:text-xl px-4 xxs:px-2">
            Take your first steps in creating a brighter future
          </p>
        </div>
      </Fade>
      <Fade triggerOnce delay={500}>
        <div className="block">
          <Link href="/">
            <a className="transition duration-500 ease-in-out transform hover:-translate-y-1 hover:opacity-90 text-white border-2 border-primary bg-primary inline-block rounded font-primaryMedium px-12 sm:px-12 py-2.5 lg:py-3 my-4 text-base md:text-lg 2xl:text-xl  max-w-320">
              Get estimate
            </a>
          </Link>
        </div>
      </Fade>
    </div>
  );
};

export default FormGstEstimate;
